import { Component, Input, OnInit } from '@angular/core';
import { TopNavBaseComponent } from 'src/app/base/components/top-nav-base.component';
import { SidenavComponent } from 'src/app/gigmonster/components/sidenav/sidenav.component';
import { HttpClient } from '@angular/common/http';
import { Route, Router } from '@angular/router';
import { NavService } from 'src/app/base/services/nav/nav.service';
import { AuthService } from 'src/app/base/services/auth/auth.service';
import { ActivatedRoute } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { PsuedoLoginPageInformation } from '../easysuite-superstructure/easysuite-superstructure.component';
import { findFirstPageLink, buildNavArray, navigate } from '../../../base/helpers';

@Component({
    selector: 'app-easysuite-top-nav',
    templateUrl: './easysuite-top-nav.component.html',
    styleUrls: ['./easysuite-top-nav.component.css']
})
export class EasysuiteTopNavComponent extends TopNavBaseComponent implements OnInit {

    @Input() psuedoLoginInfo: PsuedoLoginPageInformation = null;

    data: any = [];
    mobileMenuOpen = false;
    openMenus: { [key: string]: boolean } = {};
    isDesktop = true;

    constructor(public sideNav: SidenavComponent,
        public http: HttpClient,
        public router: Router,
        public navService: NavService,
        public authService: AuthService,
        public activated: ActivatedRoute,
        public app: AppComponent,) {
        super(sideNav, http, router, navService, authService, activated, app);
    }

    /**
     * overrides ngonicit in topnavbase, used because we care about descendants as well
     */
    ngOnInit(): void {
        this.checkScreen();
        window.addEventListener('resize', this.checkScreen.bind(this));
        
        this.data = [];

        let filteredRoutes = this.router.config.filter(x => x.path.split("/").length == 1 && x.path != "auth" && x.path != "**");

        filteredRoutes.forEach(x => {
            this.data.push(x);
        });

        this.data = this.data.sort(this.asIsOrder);

        this.data.forEach(route => {
            let tempRoute = { ...route };
            
            // Create the correct link for parent routes.
            tempRoute.childNavs = buildNavArray(this.router.config, tempRoute.path, 0);

            let link = "/" + tempRoute.path;

            // Parent has no page; search recursively for the first valid descendant's link.
            if (!tempRoute.data?.hasPage && tempRoute.childNavs && tempRoute.childNavs.length > 0) {
                const validLink = findFirstPageLink(tempRoute.childNavs);
                if (validLink) {
                    link = validLink;
                }
            }
            
            tempRoute.link = link;
            
            this.data[this.data.indexOf(route)] = tempRoute;
        });
    }

    checkScreen() {
        this.isDesktop = window.innerWidth > 991;
        if (this.isDesktop) {
            this.mobileMenuOpen = false;
        }
    }

    toggleMobileMenu() {
        this.mobileMenuOpen = !this.mobileMenuOpen;
    }

    toggleMenu(id: string | number, event: Event) {
        if (!this.isDesktop) {
            event.preventDefault();
            this.openMenus[id] = !this.openMenus[id];
        }
    }

    isActive(link): boolean {
        link = link.split('/');
        link = link[1];
        //check if this.router.url minus any http parameters matches the link
        let url = this.router.url.split("?")[0].split('/')[1];
        return url == link;
    }

    asIsOrder(a, b) {
        if(a.data?.sortOrder && b.data?.sortOrder){
            return Number.parseInt(a.data.sortOrder) > Number.parseInt(b.data.sortOrder) ? 1 : -1;

        }else{
            return Number.parseInt(a.sortOrder) > Number.parseInt(b.sortOrder) ? 1 : -1;

        }
    }
    loadNavOnClick(link: string): void {
        navigate(this.router, link);
    }

    ngOnDestroy() {
        window.removeEventListener('resize', this.checkScreen.bind(this));
    }
}
